import React, { useContext } from "react";
import { Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { useState } from "react";
import { AlertContext } from "../../context/alertContext";

const { Dragger } = Upload;

const UploadFiles = ({ types, files, setFiles, handleReadFile, setFileChanged, editing, maxSize, 'data-testid': dataTestId, onFileRemove }) => {
    const { set_alertOptions } = useContext(AlertContext);

    const toggleAlert = (type, message, description, hide = true, time = 5) => {
        set_alertOptions(() => ({
            status: true,
            type,
            message,
            description,
        }));

        if (hide) {
            setTimeout(() => {
                set_alertOptions(() => ({
                    status: false,
                    type,
                    message,
                    description,
                }));
            }, time * 1000);
        }
    };

    const props = {
        name: "file",
        multiple: false,
        fileList: files,  // Controlled fileList
        beforeUpload: (file) => {
            console.log("file :", file);
            const fileExtension = file.name.substring(file.name.lastIndexOf("."), file.name.length);
            // console.log("fileExtension :", fileExtension);
            console.log("fileExtension :", fileExtension);
            if (file.size > maxSize) {
                const msgText = `File size should not exceed ${(maxSize / (1024 * 1024))}MB.`;
                toggleAlert("error", "Error", msgText);
                return Upload.LIST_IGNORE;
            }
            else if (!types.includes(fileExtension)) {
                const msgText = `${file.name} is not an allowed file type`;
                toggleAlert("error", "Error", msgText);
                return Upload.LIST_IGNORE;
            }
            else {
                if(files.length > 0){
                    console.log("File changed: ", true);
                }
                if(editing){
                    setFileChanged(true);
                }
                handleReadFile(file);
            }

            return false;
        },
        onChange(info) {
            if (info.file.status === 'removed') {
                console.log("file removed");
                setFiles(); // Clear the list when file is removed
                if(editing){
                    setFileChanged(true);
                }
                // Call the callback to clear preview
                if (onFileRemove) {
                    onFileRemove();
                }
            }
        },
        onRemove: (file) => {
            setFiles(); // Reset the fileList when file is removed
            if(editing){
                setFileChanged(true);
            }
            // Call the callback to clear preview
            if (onFileRemove) {
                onFileRemove();
            }
        },
    };

    return (
        <Dragger {...props} data-testid={dataTestId || "env-var-upload-file-input"}>
            <p className="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p className="ant-upload-text">
                Browse or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">Supported file formats: .env, .txt, .json</p>
        </Dragger>
    );
};

export default UploadFiles;